{
  "it": {
    "cart": {
      "title": "Carrello",
      "lead": "Raccogli ciò che vuoi comprare nel gioco e scopri dove trovarlo. Ogni articolo va al posto più economico che lo vende, a meno che tu non ne scelga un altro.",
      "addToCart": "Aggiungi al carrello",
      "addLoadout": "Aggiungi i componenti non di serie al carrello",
      "clear": "Svuota carrello",
      "confirmClear": "Rimuovere tutto dal carrello?",
      "remove": "Rimuovi",
      "quantity": "Quantità",
      "unitPrice": "%{price} cad.",
      "buyElsewhere": "Compra altrove",
      "cheapest": "Più economico",
      "planPick": "Lascia scegliere al piano",
      "pinned": "La tua scelta",
      "tripPick": "Scelto per il percorso",
      "unplaced": "Luogo sconosciuto",
      "totals": {
        "total": "Totale",
        "items": "Articoli",
        "stops": "Tappe",
        "unavailable": "Non venduto da nessuna parte"
      },
      "unavailable": {
        "title": "Non venduto da nessuna parte",
        "text": "Per quanto ne sappiamo nessuno vende questi articoli al momento, quindi sono esclusi dal totale."
      },
      "empty": {
        "title": "Il tuo carrello è vuoto",
        "text": "Aggiungi merci, componenti o equipaggiamento dal catalogo per pianificare dove acquistarli."
      },
      "messages": {
        "added": "%{name} aggiunto a %{list}.",
        "addFailed": "Impossibile aggiungere l'articolo al carrello.",
        "updateFailed": "Impossibile aggiornare il carrello.",
        "accountRequired": "Accedi per usare il carrello.",
        "loadoutAdded": {
          "one": "%{count} componente aggiunto a %{list}.",
          "other": "%{count} componenti aggiunti a %{list}."
        }
      },
      "lists": {
        "shown": "Lista",
        "create": "Nuova lista",
        "rename": "Rinomina lista",
        "delete": "Elimina lista",
        "name": "Nome",
        "activate": "Imposta come attiva",
        "isActive": "Lista attiva",
        "confirmDelete": "Eliminare la lista %{name} e tutto il suo contenuto?",
        "messages": {
          "saveFailed": "Impossibile salvare la lista."
        }
      },
      "widget": {
        "expand": "Mostra carrello",
        "collapse": "Nascondi carrello",
        "open": "Apri carrello",
        "unavailable": "Non in vendita",
        "more": {
          "one": "+%{count} altro articolo",
          "other": "+%{count} altri articoli"
        }
      },
      "strategies": {
        "cheapest": {
          "label": "Più economico",
          "hint": "Ogni articolo nel luogo più economico che lo vende"
        },
        "stops": {
          "label": "Meno fermate",
          "hint": "Comprare tutto nel minor numero di luoghi, pagando di più dove questo evita una fermata"
        },
        "distance": {
          "label": "Percorso più breve",
          "hint": "Tenere le fermate sugli stessi pianeti e nello stesso sistema quando possibile, pagando di più dove questo riduce il viaggio"
        }
      },
      "pick": {
        "title": "Aggiungi %{name} a una lista",
        "hint": {
          "one": "%{count} articolo",
          "other": "%{count} articoli"
        },
        "activeHint": {
          "one": "Lista attiva · %{count} articolo",
          "other": "Lista attiva · %{count} articoli"
        },
        "loadoutParts": "componenti non di serie",
        "question": "Aggiungi a:"
      },
      "fleetLists": {
        "title": "Liste della spesa",
        "lead": "L'equipaggiamento che la flotta vuole per i suoi membri: uniformi, armature, un equipaggiamento standard. Copia una lista nel tuo carrello per vedere quanto costa e dove comprarlo.",
        "count": {
          "one": "%{count} articolo",
          "other": "%{count} articoli"
        },
        "copy": "Copia nel mio carrello",
        "copyTitle": "Copia %{name} in",
        "copyNew": "Una nuova lista",
        "copyNewHint": "Chiamata %{name} e impostata come lista attiva",
        "copyIntoHint": {
          "one": "Contiene %{count} articolo; le quantità si sommano",
          "other": "Contiene %{count} articoli; le quantità si sommano"
        },
        "showItems": "Mostra articoli",
        "hideItems": "Nascondi articoli",
        "edit": "Modifica",
        "delete": "Elimina",
        "publish": "Pubblica una lista",
        "publishTitle": "Pubblica una delle tue liste",
        "editTitle": "Modifica lista della spesa",
        "source": "La tua lista",
        "sourceHint": "Vengono copiati nella flotta articoli e quantità, non i negozi scelti.",
        "replaceFrom": "Sostituisci gli articoli con",
        "replaceHint": "Lascia vuoto per mantenere gli articoli come sono.",
        "description": "Descrizione",
        "confirmDelete": "Eliminare la lista della spesa %{name}?",
        "empty": {
          "title": "Ancora nessuna lista della spesa",
          "text": "Gli ufficiali pubblicano qui le liste dal proprio carrello, perché i membri le copino nel loro."
        },
        "messages": {
          "copied": "%{name} copiata in %{list}.",
          "copyFailed": "Impossibile copiare la lista nel tuo carrello.",
          "published": "%{name} pubblicata.",
          "updated": "%{name} aggiornata.",
          "saveFailed": "Impossibile salvare la lista della spesa.",
          "deleted": "Lista della spesa eliminata.",
          "deleteFailed": "Impossibile eliminare la lista della spesa."
        }
      }
    }
  }
}
